import { BigNumber } from '../utils/bignumber';
import moment from 'moment';

import { NULL_BYTES32, NULL_ECDSA_SIGNATURE, NULL_ADDRESS } from '../utils/constants'
import { ECDSASignature } from './ecdsa_signature'

export const POLICY_ORDER_DATA_DEFAULTS = {
  applicationHash: NULL_BYTES32,
  quoteHash: NULL_BYTES32,
  premium: new BigNumber(0),
  coverageLimit: new BigNumber(0),
  duration: new BigNumber(
    moment()
      .add(20, 'years')
      .unix()
  ),
  carrier: NULL_ADDRESS,
  relayer: NULL_ADDRESS,
  relayerFee: new BigNumber(0),
  expiration: new BigNumber(
    moment()
      .add(30, 'days')
      .unix()
  ),
  carrierSignature: NULL_ECDSA_SIGNATURE
}

// V1
export interface PolicyOrderData {
  applicationHash?: string;
  quoteHash?: string;
  premium?: BigNumber;
  coverageLimit?: BigNumber;
  duration?: BigNumber;
  carrier?: string;
  expiration?: BigNumber;
  insuredSignature?: ECDSASignature;
  carrierSignature?: ECDSASignature;
}

// V2
// export interface PolicyOrderDataV2 {
//     version?: string;
//     orderHash?: string;
//     premiumAmount?: BigNumber;
//     premiumToken?: string;
//     coverageAmount?: BigNumber;
//     coverageToken?: string;
//     policyContract?: string;
//     insured?: string;
//     carrier?: string;
//     relayer?: string;
//     underwriter?; string
//     relayerFee?: BigNumber;
//     underwriterFee?: BigNumber;
//     expiration?: BigNumber;
//     salt?: BigNumber;
//     insuredSignature?: ECDSASignature;
//     carrierSignature?: ECDSASignature;
// }
